module.exports = __webpack_public_path__ + "static/camera6-0c3b21b11c0315d7d8941deebf3e3bf6.jpg";